import { SmartSubscribe } from '@dinosband/bv-main-client'
import { subscribeMessageDeleted } from '@dinosband/bv-messenger-client'
import { Message } from '@dinosband/bv-messenger-schema'
import { BvDataCenterContext } from '..'
import { BvSubscriber } from './manager/subscriber'

export class MessageDeleteSubscriber extends BvSubscriber<Message> {

  context: BvDataCenterContext
  chatRoomIds: number[]

  constructor (context: BvDataCenterContext, chatRoomIds: number[], callback: (value: Message) => void) {
    super(callback as unknown as (value: Message | Message[]) => void)
    this.context = context
    this.chatRoomIds = chatRoomIds
  }

  protected async query () {
    return undefined
  }

  protected async subscribe () {
    const subscription = subscribeMessageDeleted(await this.context.messengerClient.getClient(), this.chatRoomIds).subscribe({
      next: async (value) => {
        if (value.data?.deletedMessage) {
          this.callback(value.data.deletedMessage)
        }
      },
      error: console.error,
    })
    return subscription as unknown as SmartSubscribe
  }

}

